<template>
  <component :is="props.tag" v-bind="rootProps">
    <slot>
      <template v-if="props.text">
        {{ props.text }}
      </template>
      <span v-else v-html="props.html" />
    </slot>
  </component>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    tag?: string
    html?: string
    type?: string
    text?: string
    weight?: string
    size?: string
    leading?: string
    tracking?: string
    color?: string
    name?: string
  }>(),
  {
    tag: 'span',
    weight: 'font-normal',
    leading: 'leading-snug',
    tracking: 'tracking-normal',
    color: 'text-inherit',
  },
)

const rootProps = computed(() => ({
  class: [
    props.size,
    props.weight,
    props.leading,
    props.color,
    props.type,
    props.name,
    props.size && (props.size.includes('xl') || props.size.includes('lg'))
      ? ['font-brand tracking-tight']
      : [props.tracking],
  ],
}))
</script>
